import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "../../Components/FormElements/Button";

export const OffLine = () => {
  const router = useHistory();
  const [loadingClick, setLoadingClick] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    updateOnlineStatus();

    window.digitalData.push({
      error: {
        code: "ErrorInversionGlobal",
        message: "No hay conexión a internet",
      },
      event: "trackError",
    });

    return () => window.removeEventListener("online", updateOnlineStatus);

  }, []);

  function updateOnlineStatus() {
    navigator.onLine ? router.goBack() : console.log("offline");
  }

  const handleBack = () => {
    setLoadingClick(true);

    setTimeout(() => {
      setLoadingClick(false);
    }, 1000);
  };

  return (
    <div className="wrap">
      <div className="">
        <div className="content-error">
          <div className="content-error__box">
            <div className="content-error__mueble">
              <div className={`content-error__declaration`}></div>
            </div>
          </div>
          <div>
            <div className="content-error__texts">
              <p className="content-error__title">¡Lo sentimos!</p>

              <p className="content-error__subtitle">
                No tienes conexión a internet. Revisa y vuelve a intentar.
              </p>
            </div>
            <div className="content-error__actionsOff">
              <Button
                type="button"
                onClick={handleBack}
                className={loadingClick ? "is-loading" : ""}
              >
                Volver a intentar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
